<template>
  <div>
    <div class="row mb-4">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/bookings' }"
          >bookings</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- {{ booking_summary }} -->
    <div class="row justify-content-center">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="row justify-content-between">
            <div class="col-auto mr-auto">
              <h5>Booking Summary</h5>
            </div>
            <div class="col-auto">
              <el-button-group>
                <el-button
                  type="primary"
                  v-if="hasAccessOnExtend"
                  icon="el-icon-plus"
                  @click="handleExtend"
                  :disabled="isExtendDisabled"
                >
                  <!--    -->
                  Extend
                </el-button>
                <el-button
                  type="primary"
                  v-if="hasAccessonReduce"
                  icon="el-icon-minus"
                  @click="handleReduce"
                  :disabled="isReduceDisabled"
                >
                  Reduce
                  <!--     -->
                </el-button>
              </el-button-group>
            </div>
          </div>
        </div>
        <hr />
        <div class="row justify-content-center">
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Site</h6>
            <h5>{{ booking_summary.site }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Station</h6>
            <h5>{{ booking_summary.station }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Connection</h6>
            <h5>{{ booking_summary.connection }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Status</h6>
            <h5>{{ booking_summary.status }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Start Time</h6>
            <h5>{{ booking_summary.start_time }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Est. End Time</h6>
            <h5>{{ booking_summary.est_end_time }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Time Remaining</h6>
            <h5>{{ remainingTime }}</h5>
          </div>
          <div class="col-sm-6 col-lg-3">
            <h6 class="text-muted">Total Hours Reserved</h6>

            <h5>{{ booking_summary.total_hours_reserved }}</h5>
          </div>
        </div>
      </div>
    </div>
    <!-- {{ newbooking_summary }} -->
    <!-- financial information card -->
    <div class="row justify-content-center">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="row justify-content-between">
            <div class="col-auto mr-auto">
              <h5>Payment Summary</h5>
            </div>
            <div class="col-auto">
              <el-button-group>
                <el-button
                  type="primary"
                  v-if="hasAccessonRefund"
                  icon="el-icon-refresh-left"
                  @click="handleRefund"
                  :disabled="isRefundDisabled"
                >
                  <!--   -->
                  Refund
                </el-button>
              </el-button-group>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <h6 class="text-muted">Total Paid</h6>
            <!-- {{ totalAmountPaid }}  -->
            <h5>{{ booking_summary.total_amount_paid }}</h5>
          </div>
          <div class="col-sm-6 col-lg-4">
            <h6 class="text-muted">Total Refund</h6>
            <!-- {{ totalRefund }} -->
            <h5>{{ booking_summary.total_refunds }}</h5>
          </div>
          <div class="col-sm-6 col-lg-4">
            <h6 class="text-muted">Net Total</h6>
            <!-- {{netTotal}} -->
            <h5>{{ booking_summary.NetTotalamount }}</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 card">
        <div class="card-header">
          <h5>Transaction</h5>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                placeholder="Search"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              >
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            >
            </p-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- extend modal -->
    <modal
      v-if="modals.extend"
      :show.sync="modals.extend"
      body-classes="p-0"
      :show-header="false"
    >
      <form-wizard
        @on-change="tabChange"
        title="Extend Booking"
        subtitle=""
        color="#66615B"
        shape="tab"
        ref="extendWizardForm"
      >
        <template slot="step" slot-scope="props">
          <wizard-step
            :tab="props.tab"
            :transition="props.transition"
            :key="props.tab.title"
            :index="props.index"
          >
          </wizard-step>
        </template>
        <tab-content title="Add Hours" icon="fas fa-clock">
          <div class="row justify-content-center">
            <div class="col-sm-5">
              <p>Add Hours:</p>
              <el-slider class="slider-primary" v-model="extendHour">
              </el-slider>
              <el-input-number
                v-model="extendHour"
                :step="1"
                :min="minAllowedExtensionHour"
                :max="maxAllowedExtensionHour"
                step-strictly
              >
              </el-input-number>
              <label class="text-info"
                >Either use the slider to enter number of hours or enter in the
                text field.</label
              >
              <label class="text-danger">
                ** Min: {{ minAllowedExtensionHour }}, Max:
                {{ maxAllowedExtensionHour }}
              </label>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-sm-5">
              <p>Estimated End Time:</p>
              <p>{{ newEndTime }}</p>
            </div>
          </div>
        </tab-content>
        <tab-content title="Payment" icon="fas fa-credit-card">
          <ul id="example-1">
            <li
              class="text-danger"
              v-for="error in errorFromSquare"
              :key="error"
            >
              {{ error.detail }}
            </li>
          </ul>
          <div class="row mb-3">
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-visa fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-mastercard fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-amex fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-jcb fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-discover fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-diners-club fa-2x"></i>
            </div>
          </div>
          <div id="form-container">
            <div id="sq-ccbox">
              <form>
                <div id="card-container"></div>
                <div v-if="isCardInitialized">
                  <button
                    :disabled="paymentDisabled"
                    class="button-credit-card"
                    type="button"
                    @click="makePayment($event)"
                  >
                    Pay ${{ extendHour }}.00
                  </button>
                </div>
                <div class="loading" v-else-if="!isCardInitialized">
                  Loading ...
                </div>
              </form>
            </div>
          </div>
        </tab-content>
        <tab-content title="Share receipt" icon="fas fa-share">
          <div>
            <p>Enter mailId to share receipt</p>
          </div>
          <div class="col-md-12">
            <fg-input
              class="col-12"
              placeholder="Email"
              addon-left-icon="nc-icon nc-email-85"
              v-model="email"
            >
            </fg-input>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-success btn-block text-center"
              :disabled="!isValidEmail"
              @click="sendReceipt()"
            >
              Send Receipt
            </button>
          </div>
        </tab-content>
        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0 && !props.isLastStep"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >
              Previous
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="[0].includes(props.activeTabIndex)"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
            >
              Next
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </modal>

    <!-- refund modal -->
    <modal
      :show.sync="modals.refund"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="modal-title">Issue Refund</h5>
      <p class="text-danger" v-show="errors.has('refundType')">
        {{ errors.first("refundType") }}
      </p>
      <h6 class="text-info">Choose type of refund</h6>
      <div class="row">
        <div class="col-12">
          <p-radio
            v-model="refundRadioButtons.enabledRadio"
            label="full"
            name="refundType"
            v-validate="'required'"
          >
            Full Refund
            <span style="color: gray; font-style: italic"
              >**Amount to be refunded: {{ totalrefundAllowed }}</span
            >
          </p-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p-radio
            v-model="refundRadioButtons.enabledRadio"
            label="partial"
            name="refundType"
            v-validate="'required'"
          >
            Partial Refund
          </p-radio>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="form-inline">
          <label class="col-sm-4 col-form-label">Amount to Refund</label>
          <fg-input
            addon-left-icon="fa fa-usd"
            :disabled="refundRadioButtons.enabledRadio === 'full'"
            type="number"
            min="0"
            v-model="partialRefundValue"
            v-validate="rulePartialRefundValue"
            name="partialRefundValue"
          >
          </fg-input>
        </div>
        <p class="text-danger" v-show="errors.has('partialRefundValue')">
          {{ errors.first("partialRefundValue") }}
        </p>
      </div>
      <div class="row justify-content-center">
        <p class="text-muted font-italic">
          **Refund up to {{ totalrefundAllowed }}
        </p>
      </div>
      <template v-if="booking_summary.status != 'CLOSED'">
        <hr />
        <p class="text-danger" v-show="errors.has('keepConnectionActive')">
          {{ errors.first("keepConnectionActive") }}
        </p>
        <h6 class="text-info">Choose to keep connection open</h6>
        <div class="row">
          <div class="col-12">
            <p-radio
              v-model="refundRadioButtons.keepConnectionActive"
              v-validate="ruleKeepConnectionOpen"
              label="close"
              name="keepConnectionActive"
            >
              Close connection
            </p-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p-radio
              v-model="refundRadioButtons.keepConnectionActive"
              v-validate="ruleKeepConnectionOpen"
              label="open"
              name="keepConnectionActive"
            >
              Keep connection open
            </p-radio>
          </div>
        </div>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="modals.refund = false"
          >Cancel</p-button
        >
        <p-button type="success" @click.native="validateRefund"
          >Refund</p-button
        >
      </template>
    </modal>

    <!-- reduce modal -->
    <modal
      :show.sync="modals.reduce"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="modal-title">Reduce reserved hours</h5>
      <template>
        <div class="row">
          <div class="col-8">
            <h6 class="text-muted">Total :</h6>
          </div>
          <div class="col-4">
            <h6>{{ booking_summary.total_hours_reserved }}</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <h6 class="text-muted">Time Remaining:</h6>
          </div>
          <div class="col-4">
            <h6>{{ remainingTime }}</h6>
          </div>
        </div>
        <hr />
        <p class="text-danger" v-show="errors.has('hoursToReduce')">
          {{ errors.first("hoursToReduce") }}
        </p>
        <div class="row">
          <h6 class="col-6 col-form-label">Hours to deduct:</h6>
          <div class="col-6">
            <el-input-number
              :step="1"
              :min="minHourToReduce"
              :max="maxHourToReduce"
              step-strictly
              v-validate="'required'"
              name="hoursToReduce"
              v-model="hoursToReduce"
            >
            </el-input-number>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-6">
            <p class="text-primary font-weight-bold">
              Min Hour: {{ minHourToReduce }}, Max Hour: {{ maxHourToReduce }}
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <p class="text-warning font-italic">
            **This will refund hours reduced
          </p>
        </div>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="modals.reduce = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="validateReduce"
          >Reduce</p-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Button, ButtonGroup, InputNumber, Slider } from "element-ui";
import HTTP from "src/util/http-common.js";
import Modal from "src/components/UIComponents/Modal.vue";
import { EventBus } from "src/util/event-bus.js";
import swal from "sweetalert2";
import {
  FormWizard,
  TabContent,
  WizardButton,
  WizardStep,
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import "vue-loading-overlay/dist/vue-loading.css";
import { PERMISSION_MAPPING } from "src/util/permission-constants.js";

export default {
  components: {
    [Button.name]: Button,
    [ButtonGroup.name]: ButtonGroup,
    Modal,
    [InputNumber.name]: InputNumber,
    [Slider.name]: Slider,
    FormWizard,
    TabContent,
    WizardButton,
    WizardStep,
  },
  data() {
    return {
      email: "",
      appId: process.env.VUE_APP_SQUARE_APPLICATION_ID,
      locationId: process.env.VUE_APP_LOCATION_ID,
      card: null,
      isCardInitialized: false,
      paymentDisabled: false,
      loadpaying: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "created_at_iso",
          label: "Created At",
          minWidth: 150,
        },
        {
          prop: "username",
          label: "User",
          minWidth: 120,
        },
        {
          prop: "reserved_hours",
          label: "Reserved Hours",
          minWidth: 120,
        },
        {
          prop: "formatted_amount",
          label: "Amount",
          minWidth: 110,
          fixed: "right",
        },
        {
          prop: "transaction_type",
          label: "TYPE",
          minWidth: 100,
        },
      ],
      tableData: [],
      booking_summary: {
        status: "",
        time_remaining_in_hour: "",
        time_remaining_in_minutes: "",
        actual_end_time: null,
        connection: "",
        epoch_end_time: null,
        epoch_start_time: null,
        est_end_time: null,
        id: null,
        site: "",
        site_id: null,
        start_time: null,
        station: null,
        status: null,
        total_allowed_refunds: null,
        total_amount_paid: 0,
        total_hours_reserved: null,
        total_refunds: null,
      },
      newbooking_summary: null,
      modals: {
        refund: false,
        reduce: false,
        extend: false,
      },
      hoursToReduce: null,
      extendHour: 0,
      newEndTime: 1,
      errorFromSquare: [],
      nonce: "",
      paymentForm: null,
      haspermissions: null,
      partialRefundValue: null,
      refundRadioButtons: {
        enabledRadio: "",
        keepConnectionActive: "",
      },
    };
  },
  computed: {
    isValidEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.email);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    status() {
      return this.booking_summary.status.toUpperCase();
    },
    remainingTime() {
      const hour = this.remainingTimeinHour;
      const min = this.remainingTimeinMinutes;

      return hour + "h " + min + "m";
    },
    remainingTimeinHour() {
      let hour = 0;
      if (this.booking_summary.time_remaining_in_hour) {
        hour = this.booking_summary.time_remaining_in_hour;
      }
      return hour;
    },
    minHourToReduce() {
      if (this.remainingTimeinHour == 0) {
        return 0;
      }
      return 1;
    },
    maxHourToReduce() {
      return this.remainingTimeinHour;
    },
    remainingTimeinMinutes() {
      let min = 0;
      if (this.booking_summary.time_remaining_in_minutes) {
        min = this.booking_summary.time_remaining_in_minutes;
      }
      return min;
    },
    totalRefund() {
      return this.currencyFormatter().format(
        this.newbooking_summary.total_refunds
      );
    },
    totalAmountPaid() {
      return this.currencyFormatter().format(
        this.booking_summary.total_amount_paid
      );
    },
    netTotal() {
      return this.currencyFormatter().format(
        this.newbooking_summary.total_amount_paid -
          this.newbooking_summary.total_refunds
      );
    },
    minAllowedExtensionHour() {
      if (99 - this.newbooking_summary.total_hours_reserved >= 1) {
        return 1;
      } else {
        return 0;
      }
    },
    maxAllowedExtensionHour() {
      // allowable hour to add on a booking
      const diff = 99 - this.newbooking_summary.total_hours_reserved;
      if (diff == 0) {
        return 0;
      } else {
        return diff;
      }
    },
    summary() {
      return {
        inputHours: this.extendHour,
        startUpCost: 1,
        costPerHour: 1,
      };
    },
    totalrefundAllowed() {
      if (this.newbooking_summary) {
        return this.currencyFormatter().format(
          this.newbooking_summary.total_allowed_refunds / 100
        );
      }
    },
    ruleKeepConnectionOpen() {
      // this is on the refund modal, it decides whether keeping connection active
      // is required selection
      if (this.booking_summary.status != "CLOSED") {
        return "required";
      }
      return "";
    },
    rulePartialRefundValue() {
      if (this.refundRadioButtons.enabledRadio == "partial") {
        return "required";
      }
      return "";
    },
    isRefundDisabled() {
      if (this.newbooking_summary) {
        let isDisabled = false;
        if (
          this.newbooking_summary.total_amount_paid ==
          this.newbooking_summary.total_refunds
        ) {
          // disable refund if full amount has been refunded.
          isDisabled = true;
          return isDisabled;
        }
        return isDisabled;
      }
    },
    isReduceDisabled() {
      if (this.newbooking_summary) {
        const curr_time = Math.floor(new Date().getTime() / 1000); // get the timestamp in seconds
        if (curr_time > this.newbooking_summary.epoch_end_time) {
          return true;
        } else if (this.newbooking_summary.status == "CLOSED") {
          return true;
        } else if (this.newbooking_summary.time_remaining_in_hour < 1) {
          return true;
        }
        return false;
      }
    },
    isExtendDisabled() {
      // extend is disabled if booking is closed as in current_time > booking.end_time
      const curr_time = Math.floor(new Date().getTime() / 1000); // get the timestamp in seconds
      if (this.newbooking_summary) {
        if (curr_time > this.newbooking_summary.epoch_end_time) {
          return true;
        } else if (this.maxAllowedExtensionHour == 0) {
          return true;
        } else if (this.newbooking_summary.status == "CLOSED") {
          // put this status on config file so we are not hard coding it.
          return true;
        }
        return false;
      }
    },
    hasAccessOnExtend() {
      if (this.haspermissions) {
        let permissionExists = this.haspermissions.includes(
          "booking.extend.post"
        );
        return permissionExists;
      } else {
        return false;
      }

      // if ("site_id" in this.booking_summary) {
      //   const siteId = this.booking_summary.site_id;
      //   let permissionExists = Object.values(
      //     this.getPermissionsLocalStorage()[siteId]
      //   ).includes(PERMISSION_MAPPING.BOOKING_EXTEND_POST);
      //   console.log("permission on extend", permissionExists);
      //   return permissionExists;
      // }
      // return false;
    },
    hasAccessonRefund() {
      if (this.haspermissions) {
        // const siteId = this.booking_summary.site_id;

        // let permissionExists = Object.values(
        //   this.getPermissionsLocalStorage()[siteId]
        // ).includes(PERMISSION_MAPPING.BOOKING_REFUND_POST);

        let permissionExists = this.haspermissions.includes(
          "booking.refund.post"
        );
        return permissionExists;
      }
      // if ("site_id" in this.booking_summary) {
      //   const siteId = this.booking_summary.site_id;
      //   let permissionExists = Object.values(
      //     this.getPermissionsLocalStorage()[siteId]
      //   ).includes(PERMISSION_MAPPING.BOOKING_REFUND_POST);
      //   console.log("permission on refund", permissionExists);
      //   return permissionExists;

      // }
      return false;
    },
    hasAccessonReduce() {
      if (this.haspermissions) {
        let permissionExists = this.haspermissions.includes(
          "booking.reduce.post"
        );
        return permissionExists;
      } else {
        return false;
      }

      //   if ("site_id" in this.booking_summary) {
      //     const siteId = this.booking_summary.site_id;
      //     let permissionExists = Object.values(
      //       this.getPermissionsLocalStorage()[siteId]
      //     ).includes(PERMISSION_MAPPING.BOOKING_REDUCE_POST);
      //     console.log("permission on reduce", permissionExists);
      //     return permissionExists;
      //   }
      //   return false;
      // },
    },
  },
  watch: {
    extendHour: function (newVal, oldVal) {
      this.newEndTime = "Waiting for you to stop typing......";
      this.debouncedGetAnswer();
    },
    "pagination.perPage": function (newVal, oldVal) {
      this.pagination.currentPage = 1;
      this.setBookingLogs();
    },
    "modals.extend": function (newVal, oldVal) {
      if (newVal === false && this.paymentForm !== null) {
        this.destroyCard();
      }
    },
    "modals.refund": function (newVal, oldVal) {
      if (newVal == false) {
        this.refundRadioButtons.enabledRadio = "";
        this.refundRadioButtons.keepConnectionActive = "";
        this.partialRefundValue = null;
      }
      this.errors.clear();
    },
    "modals.reduce": function (newVal, oldVal) {
      this.errors.clear();
    },
  },
  created() {
    this.setBookingSummary();
    this.setBookingLogs();
  },
  mounted() {
    this.debouncedGetAnswer = _.debounce(this.getNewEndTime, 500);

    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;
    this.haspermissions = permissions;
    var canShowBooking = permissions.includes("booking.get");

    if (canShowBooking === false) {
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    sendReceipt() {
      if (this.isValidEmail && this.newbooking_summary.id) {
        let params = {
          email: this.email,
          booking_id: this.newbooking_summary.id,
        };
        var loader = this.$loading.show();
        HTTP.post("api/v1/booking/send-receipt", params)
          .then((response) => {
            this.$notify({
              group: "general",
              title: "Success",
              text: "Receipt send Successfully",
              type: "success",
            });
            loader.hide();
          })
          .catch((err) => {
            loader.hide();
            this.$notify({
              group: "general",
              title: "Error on sending receipt",
              text: err.response.data.error,
              type: "error",
            });
          });
        this.modals.extend = false;
      }
    },

    async destroyCard() {
      await this.card.destroy();
      this.card = null;
      this.isCardInitialized = false;
      this.paymentForm = null;

      //this.paymentDisabled=true;
    },

    async loadCard() {
      this.card = null;
      const payments = Square.payments(this.appId, this.locationId);
      try {
        this.card = await payments.card();
        this.isCardInitialized = true;
        await this.card.attach("#card-container");
      } catch (e) {
        this.notifyVue("Initializing Card failed", e, "error");
        return;
      }
    },

    async onGetTokenizer() {
      const tokenResult = await this.card.tokenize();
      if (tokenResult.status === "OK") {
        return tokenResult.token;
      } else {
        let errorMessage = `${tokenResult.status} Card`;
        this.notifyVue("Tokenization failed", errorMessage, "error");
      }
    },

    async makePayment(event) {
      event.preventDefault();
      this.paymentDisabled = true;
      try {
        const token = await this.onGetTokenizer();
        if (token) {
          this.extend(token);
        }
      } catch (e) {
        this.notifyVue("Payment Failed", e, "error");
      }
      this.paymentDisabled = false;
    },

    handleRefund() {
      this.modals.refund = true;
    },
    handleReduce() {
      this.modals.reduce = true;
    },
    display(seconds) {
      const format = (val) => `0${Math.floor(val)}`.slice(-2);
      const hours = seconds / 3600;
      const minutes = (seconds % 3600) / 60;

      return {
        hours: Math.floor(hours),
        minutes: Math.floor(minutes),
      };
    },
    async validateRefund() {
      let validateKeepConnectionOpenRadio = true;
      if (this.ruleKeepConnectionOpen === "") {
        validateKeepConnectionOpenRadio = false;
      }

      let validatePartialRefundValue = true;
      if (this.rulePartialRefundValue === "") {
        validatePartialRefundValue = false;
      }
      const fields = [
        this.$validator.validate("refundType"),
        ...(validatePartialRefundValue
          ? [this.$validator.validate("partialRefundValue")]
          : []),
        ...(validateKeepConnectionOpenRadio
          ? [this.$validator.validate("keepConnectionActive")]
          : []),
      ];

      const results = Promise.all(fields);

      const areValid = (await results).every((isValid) => isValid);
      if (areValid) {
        this.refund();
      }
    },
    async validateReduce() {
      var result = this.$validator.validate("hoursToReduce");
      const isValid = await result;
      if (isValid) {
        this.reduce();
      }
    },
    refund() {
      this.modals.refund = false;
      let refundValue;
      const allowedRefund = this.newbooking_summary.total_allowed_refunds; // in  cents
      if (
        this.refundRadioButtons.enabledRadio == "full" &&
        allowedRefund != 0
      ) {
        refundValue = allowedRefund / 100;
      } else if (
        this.refundRadioButtons.enabledRadio == "partial" &&
        allowedRefund >= this.partialRefundValue
      ) {
        refundValue = this.partialRefundValue;
      } else {
        this.notifyVue("Error", "Refund not allowed", "error");
        return;
      }

      const params = {
        booking_id: this.newbooking_summary.id,
        amount: parseInt(refundValue),
      };
      if (this.refundRadioButtons.keepConnectionActive != "") {
        if (this.refundRadioButtons.keepConnectionActive == "open") {
          params.keep_active = true;
        } else if (this.refundRadioButtons.keepConnectionActive == "close") {
          params.keep_active = false;
        }
      }
      var loader = this.$loading.show();
      HTTP.post("api/v1/booking/refund", params)
        .then((response) => {
          loader.hide();
          const message = "Successfully refunded $" + refundValue;
          const result = response.data;
          if (result.error != null) {
            this.showSalSuccess("Partially refunded", result.error);
            this.setBookingSummary();
            this.setBookingLogs();
            this.$forceUpdate();
          } else {
            this.setBookingSummary();
            this.setBookingLogs();
            this.showSalSuccess("Refund Successful", message);
          }
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
          const errors = err.response.data.error;
          this.showSalError(
            "Error encountered while trying to refund",
            err.response.data.error
          );
        });

      this.partialRefundValue = "";
      this.refundRadioButtons.enabledRadio = "";
    },
    extend(nonce) {
      let loader = this.$loading.show();
      this.loadpaying = true;
      HTTP.post("api/v1/booking/extend", {
        hours_to_add: this.extendHour,
        booking_id: this.newbooking_summary.id,
        nonce: nonce,
      })
        .then((response) => {
          this.loadpaying = false;
          loader.hide();
          // refresh booking details
          //this.modals.extend = false;
          this.$refs.extendWizardForm.nextTab();
          this.setBookingSummary();
          this.setBookingLogs();
          this.showSalSuccess(
            "Extension Succesful!",
            "Added " + this.extendHour + "hr to booking."
          );
          this.$forceUpdate();
        })
        .catch((err) => {
          this.loadpaying = false;
          loader.hide();
          console.log(err.response.data.error.errors);
          this.errorFromSquare = err.response.data.error.errors;
        });
    },
    reduce() {
      let loader = this.$loading.show();
      this.modals.reduce = false;
      HTTP.post("api/v1/booking/reduce", {
        hours_to_reduce: parseInt(this.hoursToReduce),
        //   hours_to_reduce: 1,
        booking_id: this.newbooking_summary.id,
      })
        .then((response) => {
          loader.hide();

          const result = response.data;
          if (result.error != null) {
            this.showSalSuccess("Partially reduced hour", result.error);
            this.setBookingSummary();
            this.setBookingLogs();
            this.$forceUpdate();
          } else {
            var rem =
              this.remainingTimeinHour -
              result.hours_reduce +
              "h " +
              this.remainingTimeinMinutes +
              "m";

            this.setBookingSummary();
            this.setBookingLogs();
            this.showSalSuccess(
              "Successfully reduced hour",
              "Reserved hour reduce to " + rem
            );
          }
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
          this.modals.reduce = false;
          this.showSalError("Something went wrong!", err.response.data.error);
        });
    },
    async fetchBooking() {
      const response = await HTTP.get("api/v1/booking/", {
        params: {
          booking_id: this.$route.params.bookingId,
        },
      });
      const data = await response.data;
      return data;
    },
    setBookingSummary() {
      let loader = this.$loading.show();
      this.fetchBooking()
        .then((data) => {
          this.newbooking_summary = data.booking_summary;

          this.booking_summary.site = data.booking_summary.site;
          this.booking_summary.station = data.booking_summary.station;
          this.booking_summary.status = data.booking_summary.status;

          // this.$moment.unix(results[i].end_time).format('MMMM Do YYYY, h:mm:ss a');

          //this.booking_summary.est_end_time = data.booking_summary.est_end_time;
          this.booking_summary.est_end_time = this.$moment(
            data.booking_summary.est_end_time
          ).format("llll");
          this.booking_summary.total_hours_reserved =
            data.booking_summary.total_hours_reserved;

          // let str = data.booking_summary.start_time;
          // let date = this.$moment(str);

          // console.log(date.format("llll"))

          this.booking_summary.start_time = this.$moment(
            data.booking_summary.start_time
          ).format("llll");
          //   this.booking_summary.start_time = data.booking_summary.start_time;
          this.booking_summary.connection = data.booking_summary.connection;
          this.booking_summary.time_remaining_in_hour =
            data.booking_summary.time_remaining_in_hour;
          this.booking_summary.time_remaining_in_minutes =
            data.booking_summary.time_remaining_in_minutes;

          this.booking_summary.NetTotalamount = this.currencyFormatter().format(
            (data.booking_summary.total_amount_paid -
              data.booking_summary.total_refunds) /
              100
          );
          this.booking_summary.total_refunds = this.currencyFormatter().format(
            data.booking_summary.total_refunds / 100
          );

          this.booking_summary.total_amount_paid =
            this.currencyFormatter().format(
              data.booking_summary.total_amount_paid / 100
            );
          //   this.booking_summary.     = data.booking_summary.   ;
          loader.hide();
          this.$forceUpdate();
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
          if (err.response.status === 404) {
            this.$router.push({ name: "not-found" });
          } else if (err.response.status === 403) {
            this.$router.push({ name: "forbidden" });
          } else {
            const error = err.response.data.error;
            this.$notify({
              group: "general",
              title: "Error fetching booking list",
              text: error,
              type: "error",
            });
          }
          loader.hide();
        });
    },
    async fetchLogs() {
      const response = await HTTP.get("api/v1/booking/logs", {
        params: {
          booking_id: this.$route.params.bookingId,
          page: this.pagination.currentPage,
          page_size: this.pagination.perPage,
        },
      });
      const data = await response.data;
      return data;
    },
    setBookingLogs() {
      this.fetchLogs()
        .then((data) => {
          this.tableData = data.results;
          this.pagination.total = data.total;
          this.formatTableData();
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
          const error = err.response.data.error;
          if (err.response.status === 403) {
            this.$router.push({ name: "forbidden" });
          } else {
            this.$notify({
              group: "general",
              title: "Error fetching booking list",
              text: error,
              type: "error",
            });
          }
        });
    },
    formatTableData() {
      // any other formatting needed to be done on the booking_logs
      for (let i = 0; i < this.tableData.length; i++) {
        var log = this.tableData[i];
        log.formatted_amount = this.currencyFormatter().format(
          log.amount_in_cents / 100
        );
      }
      this.$forceUpdate();
    },
    handleExtend() {
      this.modals.extend = true;
    },
    getNewEndTime() {
      this.newEndTime = "Calculating new End time...";

      HTTP.get("api/v1/utils/end_time", {
        params: {
          hours_to_add: this.extendHour,
          old_end_time: this.newbooking_summary.epoch_end_time,
        },
      })
        .then((response) => {
          this.newEndTime = response.data;
        })
        .catch((err) => {
          this.newEndTime = "Error calculating new End Time!!!";
        });
    },
    tabChange(...args) {
      const newTabId = args[1];
      if (newTabId == 1) {
        this.loadCard();
      } else {
        this.destroyCard();
      }
    },
    showSalSuccess(title, text) {
      swal({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success btn-fill",
        type: "success",
      });
    },
    showSalError(title, text) {
      swal({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-danger btn-fill",
        type: "error",
      });
    },
    inputChanged(pageNum) {
      this.setBookingLogs();
    },
    onGetCardNonce(event) {
      // Don't submit the form until SqPaymentForm returns with a nonce
      event.preventDefault();
      // Request a nonce from the SqPaymentForm object
      this.paymentForm.requestCardNonce();
    },
    newSqPaymentFormInstance() {
      let that = this;

      var applicationId = process.env.VUE_SQUARE_APPLICATION_ID;

      var paymentForm = new SqPaymentForm({
        // Initialize the payment form elements
        autoBuild: false,

        applicationId: applicationId,
        inputClass: "sq-input",

        // Customize the CSS for SqPaymentForm iframe elements
        // inputStyles: [{
        //     fontSize: '16px',
        //     lineHeight: '24px',
        //     padding: '16px',
        //     placeholderColor: '#a0a0a0',
        //     backgroundColor: 'white',
        // }],

        inputStyles: [
          {
            fontSize: "18px",
            fontFamily: "Helvetica Neue",
            padding: "15px",
            color: "#373F4A",
            lineHeight: "24px",
            placeholderColor: "#BDBFBF",
          },
        ],

        // Initialize the credit card placeholders
        cardNumber: {
          elementId: "sq-card-number",
          placeholder: "Card Number",
        },
        cvv: {
          elementId: "sq-cvv",
          placeholder: "CVV",
        },
        expirationDate: {
          elementId: "sq-expiration-date",
          placeholder: "MM/YY",
        },
        postalCode: {
          elementId: "sq-postal-code",
          placeholder: "Postal",
        },

        // SqPaymentForm callback functions
        callbacks: {
          /*
           * callback function: cardNonceResponseReceived
           * Triggered when: SqPaymentForm completes a card nonce request
           */
          cardNonceResponseReceived: function (errors, nonce, cardData) {
            if (errors) {
              errors.forEach(function (error) {
                console.log(error.message);
                that.errorFromSquare.push({ detail: error.message });
              });
              return;
            }
            // Uncomment the following block to
            // 1. assign the nonce to a form field and
            // 2. post the form to the payment processing handler
            document.getElementById("card-nonce").value = nonce;
            // document.getElementById('nonce-form').submit();
            // that.postBooking(nonce);
            that.extend(nonce);
          },
        },
        paymentFormLoaded: function () {
          this.isLoaded = true;
          /* HANDLE AS DESIRED */
        },
      });

      return paymentForm;
    },
    getPermissionsLocalStorage() {
      return JSON.parse(localStorage.getItem("permissions"));
    },
  },
};
</script>

<style scoped>
.errorbox {
  line-height: 14px;
  text-align: left;
}
.error {
  font-size: 10px;
  color: rgb(164, 0, 30);
  width: 45%;
  display: inline-block;
  margin-top: -10px;
  font-weight: 400;
}

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  background-color: #f7f8f9;
  color: #373f4a;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
  height: 100%;
}

button {
  border: 0;
  font-weight: 500;
}

fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}

#form-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  top: 40%;
  /* transform: translateY(-50%); */
}

.third {
  float: left;
  width: calc((100% - 32px) / 3);
  padding: 0;
  margin: 0 16px 16px 0;
  /* background-color: #eeeeee; */
  border-radius: 20px;
}

.third:last-of-type {
  margin-right: 0;
}

/* Define how SqPaymentForm iframes should look */
/* .sq-input {
  height: 56px;
  box-sizing: border-box;
  border: 1px solid #E0E2E3;
  background-color: #eeee;
  border-radius: 6px;
  display: inline-block;
  -webkit-transition: border-color .2s ease-in-out;
     -moz-transition: border-color .2s ease-in-out;
      -ms-transition: border-color .2s ease-in-out;
          transition: border-color .2s ease-in-out;
} */

/* Define how SqPaymentForm iframes should look when they have focus */
.sq-input--focus {
  border: 1px solid #6e4eec;
}

/* Define how SqPaymentForm iframes should look when they contain invalid values */
.sq-input--error {
  border: 1px solid #e02f2f;
}

.errorbox {
  line-height: 14px;
  text-align: left;
}

.sq-card-number {
  margin-bottom: 16px;
}

/* Customize the "Pay with Credit Card" button */
.button-credit-card {
  border-radius: 50px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  height: auto;
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 24px;
  margin-top: 16px;
  padding: 16px;
  position: relative;
  text-transform: uppercase;
  width: 100%;
  z-index: 1;
  background: linear-gradient(180deg, #8e72ff -57.14%, #6e4eec 125%);
  border: none;
  color: #fff;
}

.button-credit-card:hover {
  background: linear-gradient(180deg, #a791ff -57.14%, #856aef 125%);
  color: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
